var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccountCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 2.33337C6.98 2.33337 2.5 6.81337 2.5 12.3334C2.5 17.8534 6.98 22.3334 12.5 22.3334C18.02 22.3334 22.5 17.8534 22.5 12.3334C22.5 6.81337 18.02 2.33337 12.5 2.33337ZM12.5 5.33337C14.16 5.33337 15.5 6.67337 15.5 8.33337C15.5 9.99337 14.16 11.3334 12.5 11.3334C10.84 11.3334 9.5 9.99337 9.5 8.33337C9.5 6.67337 10.84 5.33337 12.5 5.33337ZM6.5 16.3134C7.79 18.2534 10 19.5334 12.5 19.5334C15 19.5334 17.21 18.2534 18.5 16.3134C18.47 14.3234 14.49 13.2334 12.5 13.2334C10.5 13.2334 6.53 14.3234 6.5 16.3134Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountCircle);
export default __webpack_public_path__ + "static/media/account-circle.eba296374172db14ba9ad0f3a41a72b0.svg";
export { ForwardRef as ReactComponent };